export default __webpack_public_path__ + "static/heroBg-6623a8baf466ec3ae4e88693c9dc7c27.png";